import React from "react";
import Layout from "@/components/layout";
import HeaderOne from "@/components/header-one";
import MenuContextProvider from "@/context/menu-context";
import PageHeader from "@/components/page-header";
import Footer from "@/components/footer";
import ServiceDetails from "@/components/service-details";
import ContactThree from "@/components/contact-three";

const ServiceDetailsPage = () => {
  return (
    <MenuContextProvider>
      <Layout PageTitle="Usluge">
        <HeaderOne />
        <PageHeader title="Naše usluge" name="Service" />
        <ServiceDetails />
        <ContactThree />
        <Footer />
      </Layout>
    </MenuContextProvider>
  );
};

export default ServiceDetailsPage;
